import React from 'react';
import { LoadingSpiner } from '../../../../../components';
import { ConfigFormSetupIsaAderenciaDePrecos } from './components/ConfigFormSetupIsaAderenciaDePrecos';
import styles from './SetupAderenciaDePrecos.module.scss';

export const SetupAderenciaDePrecos = () => {
    const isLoading = false;

    return (
        <div className={styles['setup-ipa__main-config-container']}>
            {isLoading && <LoadingSpiner size="md" />}
            <ConfigFormSetupIsaAderenciaDePrecos />
        </div>
    );
};

